import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ISaveServiceRequestResponse } from "../../Orchestrator/Types/Interface/IServiceRequest";
import { IAddCommentToTheTicketActionParams, IServiceRequestTicketList } from "../../Orchestrator/Types/Interface/IServiceRequestDetails";

export async function getListOfServiceRequest(bookingId: string): Promise<IApiResponse<IServiceRequestTicketList>> {
    const ENDPOINTS = await getEndpoints();
    let endpoint = ENDPOINTS.getServiceRequestTicketList;
    let queryParams = ""
    if (bookingId) {
        queryParams += `bookingId=${bookingId}`
    }
    if (queryParams != "") {
        endpoint += `?${queryParams}`
    }
    return await apiRequest<IServiceRequestTicketList>(endpoint, 'GET');
}

export async function postAddCommentToTicket(
    payload: IAddCommentToTheTicketActionParams
): Promise<IApiResponse<ISaveServiceRequestResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.addCommentToTicket(payload.ticketId);

    // Make the API request using the constructed endpoint and searchRequest
    return await apiRequest<ISaveServiceRequestResponse>(endpoint, 'POST', {
        body: JSON.stringify({ content: payload.content }),
    });
}
export async function postCloseTicket(
    ticketId: number
): Promise<IApiResponse<ISaveServiceRequestResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.closeTicket(ticketId);

    return await apiRequest<ISaveServiceRequestResponse>(endpoint, 'POST', {
        body: JSON.stringify({ status: "CANCELLED" }),
    });
}